export const getRequiredBookingConfirmationValue = (
  _sourceValue?: boolean | null,
) => true
